import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
  Alert,
} from "reactstrap";
import { toast } from "react-toastify";
import { addPackProducetApi } from "../../services/apiServices";

const AddPackItem = () => {
  const [name, setName] = useState("");
  const [amount, setAmount] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!name || !amount || !file) {
      setError("All fields are required!");
      toast.error("All fields are required!");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("amount", amount);
    formData.append("file", file);

    try {
      setLoading(true);
      const response = await addPackProducetApi(formData);

      if (response.status) {
        toast.success(response.message);
        setName("");
        setAmount("");
        setFile(null);
      } else {
        setError(response.message);
        toast.error(response.message);
      }
    } catch (err) {
      console.error(err);
      setError("Failed to create item");
      toast.error("Failed to create item");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="page-content mt-4">
      <Row className="justify-content-center">
        <Col lg={6}>
          <Card>
            <CardHeader className="bg-primary text-white">
              <h5 className="mb-0">Add New Pack Item</h5>
            </CardHeader>
            <CardBody>
              {error && <Alert color="danger">{error}</Alert>}
              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <Label for="name">Item Name</Label>
                  <Input
                    type="text"
                    id="name"
                    placeholder="Enter item name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="amount">Item Amount</Label>
                  <Input
                    type="number"
                    id="amount"
                    placeholder="Enter item amount"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="file">Item Image</Label>
                  <Input type="file" id="file" onChange={handleFileChange} />
                  {file && <p className="mt-2">Selected file: {file.name}</p>}
                </FormGroup>

                <Button color="primary" type="submit" disabled={loading}>
                  {loading ? <Spinner size="sm" /> : "Add Item"}
                </Button>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AddPackItem;
